import { formatNumber } from 'core/service/lib/number-format'

export const dashedOutOrWithPrecision = (value, precision, isRound = true) =>
  value === 0 ? '-' : formatNumber(value, precision, isRound)

export const PolicyGioValueRow = ({
  age,
  yearEndPolicy,
  annualBasicPremium,
  cumulativeBasicPremium,
  cashDrop,
  deathBenefit,
  cumulativeDeathBenefit,
  surrenderCash,
}) => {
  return (
    <tr id={`policy-value-row-${age.value}`}>
      <td className="policy-value-age">{age.value}</td>
      <td className="policy-value-year">{yearEndPolicy}</td>
      <td className="policy-value-annual-basic-premium">{dashedOutOrWithPrecision(annualBasicPremium, 2)}</td>
      <td className="policy-value-cumulative-basic-premium">{dashedOutOrWithPrecision(cumulativeBasicPremium, 2)}</td>
      <td className="policy-value-cash-drop">{dashedOutOrWithPrecision(cashDrop, 2)}</td>
      <td className="policy-value-death-benefit">{dashedOutOrWithPrecision(deathBenefit, 2)}</td>
      <td className="policy-value-cumulative-death-benefit">{dashedOutOrWithPrecision(cumulativeDeathBenefit, 2)}</td>
      <td className="policy-value-surrender-cash">{dashedOutOrWithPrecision(surrenderCash, 2)}</td>
    </tr>
  )
}
export default PolicyGioValueRow
